import { useToast } from '@opoint/infomedia-storybook'
import { useMutation } from '@tanstack/react-query'
import { useCustomAxiosInstance } from '../axios/instance'

const useUnpersistProfile = (
  profileId: number | null | undefined,
  onSuccess?: () => void,
) => {
  const apiClient = useCustomAxiosInstance()
  const { toast } = useToast()

  return useMutation(
    () =>
      apiClient({
        url: `/profiles/${profileId}/unpersist/`,
        method: 'post',
      }),
    {
      onSuccess: () => {
        toast({
          title: 'Profile was successfully unpersisted.',
          variant: 'success',
        })
        onSuccess?.()
      },
      onError: () =>
        toast({
          title: 'Something went wrong. Please try again.',
          variant: 'error',
        }),
    },
  )
}

export default useUnpersistProfile
